import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { memo, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useMediaQuery } from 'react-responsive';
import { BadgeStatus, getEndpointUrl, getTimestamp } from "../../Utils/Common";

const DataTableOffer = ({ onCallback }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/offer?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, { //
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
                // pragma: 'no-cache',
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setCustomers(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const header = (
        <Row>
            <Col md={12} className="my-2">
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText ref={inputRef} className="p-inputtext-lg" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                </div>
            </Col>
        </Row>
    );

    const statusTemplate = (row) => <BadgeStatus status={row.status} />;

    const tglTemplate = (row) => <Moment format="DD/MM/YYYY - HH:mm A">{row.createdAt}</Moment>;

    const targetTemplate = (row) => row.items?.length != 0 ? `${row.items?.length} unit` : `-`;

    const priceTemplate = (row) => <NumericFormat
        value={row.price}
        displayType={'text'}
        thousandSeparator={true}
        className="fw-medium"
        prefix={'Rp'}
        renderText={(value, props) => <span {...props}>{value}</span>} />;

    const mobileTemplate = (value) => {
        return <div className="mb-3">
            <div className="mt-2">
                <small className="text-muted">ID  <span className="fw-bold"> {value.id}</span></small><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NAMA PELANGGAN</small><br />
                <span className="fw-bold">{value.customerName}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NO HANDPHONE</small><br />
                <span className="fw-medium">{value.customerPhone}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>STATUS</small><br />
                <BadgeStatus status={value.status} /><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TGL DIBUAT</small><br />
                <span className="fw-normal fst-italic"><Moment format="DD/MM/YYYY - HH:mm A">{value.createdAt}</Moment></span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TARGET INSPEKSI</small><br />
                <span className="fw-normal">{value.items?.length != 0 ? `${value.items?.length} unit` : `-`}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TOTAL PENAWARAN</small><br />
                <span className="fw-normal">
                    <NumericFormat
                        value={value.price}
                        displayType={'text'}
                        thousandSeparator={true}
                        className="fw-medium"
                        prefix={'Rp'}
                        renderText={(value, props) => <span {...props}>{value}</span>} />
                </span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>DESKRIPSI</small><br />
                <span className="fw-normal fst-italic">{value.description}</span><br />
            </div>
        </div >;
    }

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selectionMode="single"
                onSelectionChange={(e) => { onCallback(e.value) }}>
                {isTabletOrLaptop && <Column field="id" header="ID" />}
                {isTabletOrLaptop && <Column field="status" header="STATUS" body={statusTemplate} />}
                {isTabletOrLaptop && <Column field="phone" header="TGL DIBUAT" body={tglTemplate} />}
                {isTabletOrLaptop && <Column field="customerName" header="NAMA PELANGGAN" />}
                {isTabletOrLaptop && <Column field="customerPhone" header="NO HANDPHONE" />}
                {isTabletOrLaptop && <Column field="items" header="TARGET INSPEKSI" body={targetTemplate} />}
                {isTabletOrLaptop && <Column field="price" header="HARGA" body={priceTemplate} />}
                {isMobile && <Column body={mobileTemplate} />}
            </DataTable>
        </Container>
    );
}

export default memo(DataTableOffer);
